import { QuestionnaireResultStore } from '@store/zustand/questionnaire-result/types';
import { create } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

const useQuestionnaireResultStore = create<QuestionnaireResultStore>((set) => ({
  result: null,

  saveResult: (result) => set({ result }),

  deleteResult: () => set({ result: null }),
}));

export const useQuestionnaireResult = () =>
  useQuestionnaireResultStore(useShallow(({ result }) => ({ result })));

export default useQuestionnaireResultStore;
